// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3_kGN","buttons":"SendReceipts_buttons__rUrAy","email":"SendReceipts_email__2IbKS","bookApptTitle":"SendReceipts_bookApptTitle__3232E"};